export default __webpack_public_path__ + "static/media/arrow_forward_yono.4cf35052.png";